import { useEffect, useState } from "react";

export function usePushManager(): PushManager | undefined {
  const [pushManager, setPushManager] = useState<PushManager | undefined>(undefined);

  useEffect(() => {
    const initializePushManager = async () => {
      // If available, prefer https://webkit.org/blog/16535/meet-declarative-web-push/
      if ("pushManager" in window) {
        setPushManager(window.pushManager as PushManager);
      } else {
        const registration = await navigator.serviceWorker.getRegistration();
        setPushManager(registration?.pushManager);
      }
    };

    void initializePushManager();
  }, []);

  return pushManager;
}
